import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	total: 0,
	page: 1,
	maxPage: 1,
	fetchedAllDispatches: [],
};

const dispatchSlice = createSlice({
	name: 'dispatchOrders',
	initialState: initialState,
	reducers: {
		setDispatchOrders: (state, action) => action.payload,
		reset: (state, action) => initialState,
	},
});

export const { setDispatchOrders, reset } = dispatchSlice.actions;

export default dispatchSlice.reducer;